//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System file types. */
export const ConnectionActivityType = {
    /** The assigned activity type */
    Assigned: "DB4C6D25-211C-4995-B194-9FEF7551F26B",
    /** The Bulk Update activity type */
    BulkUpdate: "10104830-5AFC-491F-9885-747521A2AA75",
    /** The connected activity type */
    Connected: "04C61230-97B6-4702-89C0-634E5AE57D6F",
    /** The Follow-up Date Reached activity type */
    FollowupDateReached: "D0FBB866-9029-4705-B3BA-07364F3D7FC1",
    /** The transferred activity type */
    Transferred: "6E7C8475-2A03-42EB-A883-5B2CC6CAE519",
};
